import { useMutation } from '@apollo/client'
import importOnDemandVideoMutation from 'graphql/mutations/importOnDemandVideoMutation'

type useImportOnDemandVideoResult = [
  (id: string) => Promise<void>,
  { loading: boolean },
]

export default function useImportOnDemandVideo(
  useMutationArgs = {},
): useImportOnDemandVideoResult {
  const [mutate, { loading }] = useMutation(
    importOnDemandVideoMutation,
    useMutationArgs,
  )

  const importOnDemandVideo = async (id: string) => {
    const { data } = await mutate({
      variables: { id },
    })

    return data
  }

  return [importOnDemandVideo, { loading }]
}
